import { useMemo, useState } from 'react';

import { useCredenciados } from '@/modulos/operacao/credenciados/dados';
import { SearchableSelect } from '@/ui/base/searchable-select';

interface CredenciadoComboboxProps {
  value: string | null;
  onChange: (value: string | null) => void;
  disabled?: boolean;
  ariaLabel?: string;
}

/**
 * Busca de credenciado por nome ou CPF/CNPJ, server-side — mesmo padrao que
 * `SearchableSelect` recomenda para esta lista (comentario de topo do componente).
 *
 * Reaproveita `useCredenciados`, a MESMA consulta que a listagem usa: nao existe
 * segunda rota so para popular select.
 */
export function CredenciadoCombobox({
  value,
  onChange,
  disabled,
  ariaLabel,
}: CredenciadoComboboxProps) {
  const [busca, setBusca] = useState('');

  const filtro = useMemo(
    () => ({ pagina: 1, tamanho: 20, busca: busca || undefined, situacao: 'ATIVO' }),
    [busca],
  );

  const { data, isLoading } = useCredenciados(filtro);

  const opcoes = useMemo(
    () =>
      (data?.itens ?? []).map((credenciado) => ({
        value: credenciado.id,
        label: credenciado.nome,
        description: credenciado.cpf_cnpj,
      })),
    [data?.itens],
  );

  return (
    <SearchableSelect
      value={value}
      onChange={onChange}
      options={opcoes}
      onSearchChange={setBusca}
      loading={isLoading}
      disabled={disabled}
      placeholder="Nenhum credenciado"
      searchPlaceholder="Buscar por nome ou CPF/CNPJ…"
      emptyMessage="Nenhum credenciado encontrado."
      ariaLabel={ariaLabel ?? 'Credenciado'}
    />
  );
}
